import styled from 'styled-components';

export const Content = styled.p`
  margin-bottom: 16px;
`;
